import { render, staticRenderFns } from "./bottomMenuItem.vue?vue&type=template&id=41512e5b&"
import script from "./bottomMenuItem.vue?vue&type=script&lang=js&"
export * from "./bottomMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports